import React, { useEffect } from 'react';
import { Hero } from './components/sections/Hero';
import { TestimoniosIniciales } from './components/sections/TestimoniosIniciales';
import { Problemas } from './components/sections/Problemas';
import { Solucion } from './components/sections/Solucion';
import { TomosCarousel } from './components/sections/TomosCarousel';
import { IncluyeCadaTomo } from './components/sections/IncluyeCadaTomo';
import { BonosCarousel } from './components/sections/BonosCarousel';
import { Oferta } from './components/sections/Oferta';
import { Profundizacion } from './components/sections/Profundizacion';
import { TestimoniosCompletos } from './components/sections/TestimoniosCompletos';
import { Garantia } from './components/sections/Garantia';
import { Faq } from './components/sections/Faq';
import { Transformacion } from './components/sections/Transformacion';
import { CierreFinal } from './components/sections/CierreFinal';
import { Footer } from './components/sections/Footer';
import { SEO_DESCRIPTION, SEO_TITLE } from './data/config';
export function App() {
  useEffect(() => {
    document.title = SEO_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = SEO_DESCRIPTION;
    document.documentElement.lang = 'es-AR';
  }, []);
  return <div className="w-full overflow-x-hidden bg-crema font-sans text-tinta" data-id="element-0" data-mp="2zn6b4vo3kbmp">
      <Hero data-id="element-1" data-mp="33n6yx6x35z6f" />
      <main data-id="element-2" data-mp="33mylndx1wrup">
        <TestimoniosIniciales data-id="element-3" data-mp="33oi2b5mmd4x0" />
        <Problemas data-id="element-4" data-mp="38l8gtoirzsgb" />
        <Solucion data-id="element-5" data-mp="38kqau06b9zv7" />
        <TomosCarousel data-id="element-6" data-mp="38k6wsujs7vmg" />
        <IncluyeCadaTomo data-id="element-7" data-mp="38o4ercumih4r" />
        <BonosCarousel data-id="element-8" data-mp="3dle2mo2d6kqh" />
        <Oferta data-id="element-9" data-mp="3dlwa6guh8ldp" />
        <Profundizacion data-id="element-10" data-mp="3dmfozootytni" />
        <TestimoniosCompletos data-id="element-11" data-mp="3dii530ufhy2k" />
        <Garantia data-id="element-12" data-mp="nw2c461hdqr3" />
        <Faq data-id="element-13" data-mp="nuhj4kutefvc" />
        <Transformacion data-id="element-14" data-mp="nv0xjrl9am4m" />
        <CierreFinal data-id="element-15" data-mp="nxwx1kcr5iv6" />
      </main>
      <Footer data-id="element-16" data-mp="su42zd55eud4" />
    </div>;
}